<template>
<span>
  <v-text-field
    v-money="currency"
    v-model="modelStart"
    hide-details
    prefix="Од"
    :disabled="disabled"
    @keyup="onKeyUp"
    color="teal lighten-2"
    :readonly="readonly" />
  <v-text-field
    v-money="currency"
    v-model="modelEnd"
    hide-details
    prefix="До"
    @keyup="onKeyUp"
    :disabled="disabled"
    color="teal lighten-2"
    :readonly="readonly" />
</span>
</template>
<script>
import { VMoney } from 'v-money'

export default {
  name: 'money-range',
  directives: { money: VMoney },
  data () {
    return {
      modelStart: this.value[0],
      modelEnd: this.value[1],
      currency: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    onKeyUp (e) {
      if (/^[0-9]$/i.test(e.key) || e.key === 'Enter') {
        this.onInput()
      }
    },
    onInput () {
      this.$emit('input', [this.modelStart !== '0,00' ? this.flattenDecimal(this.modelStart) : '', this.modelEnd !== '0,00' ? this.flattenDecimal(this.modelEnd) : ''])
    },
    flattenDecimal (decimal) {
      const commaIndex = decimal.indexOf(',')
      const dotIndex = decimal.indexOf('.')
      if (commaIndex >= 0 && dotIndex >= 0) {
        return decimal.replace(/\./g, '').replace(',', '.')
      } else if (commaIndex >= 0) {
        return decimal.replace(',', '.')
      }
      return decimal
    }
  },
  props: {
    value: {
      type: Array,
      default () {
        return ['', '']
      }
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
